export default __webpack_public_path__ + "static/media/paid-reviews-empty.d8b800f1.svg";